/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Total_PartialInputs */

const vi_report_total_partial = /** @type {(inputs: Report_Total_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán một phần`)
};

/**

* @param {Report_Total_PartialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_total_partial = /** @type {((inputs?: Report_Total_PartialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Total_PartialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_total_partial(inputs)
});